import styles from "./styles.module.scss";
import { Link } from "react-router-dom";

function Intro() {
    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>
                    <text>NOS SERVICES</text>
                    <p>pour la réussite de vos projets</p>
                </div>
                <div className={styles.bigbox}>
                    <div className={styles.service}>
                        <img src="/icons/e-commerce.png" alt="SEO" />
                        <div className={styles.bigText}>
                            E-commerce et Marketplaces
                        </div>
                        <div className={styles.paragraph}>
                        OrgaExpert maîtrise les technologies propres à  la création de marketplaces nos solutions vous permettent de lancer votre activité e-commerce,
                            de transformer votre site e-commerce  en marketplace
                        </div>
                        <div className={styles.arrowContainer}>
                        <Link to="/services/e_commerce">
                                <div class={styles.arrow}>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className={styles.service}>
                        <img src="/icons/desktop.png" alt="web dev" />
                        <div className={styles.bigText}>
                            DÉVELOPPEMENT WEB
                        </div>
                        <div className={styles.paragraph}>
                            Nos experts accompagnent les professionnels en quête d’une
                            meilleure accessibilité et d’une plus grande mobilité, au développement web.
                        </div>
                        <div className={styles.arrowContainer}>
                            <Link to="/services/developpementWeb">
                                <div class={styles.arrow}>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className={styles.service}>
                        <img src="/icons/smartphone.png" alt="mobile dev" />
                        <div className={styles.bigText}>
                            DÉVELOPPEMENT Mobile
                        </div>
                        <div className={styles.paragraph}>
                            Nos experts accompagnent les professionnels qui souhaitent mettre à leur
                            profit les bénéfices offerts par une application Mobile personnalisée et performante dans la durée.
                        </div>
                        <div className={styles.arrowContainer}>
                        <Link to="/services/developpementMobile">
                                <div class={styles.arrow}>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className={styles.service}>
                        <img src="/icons/assist.png" alt="SEO" />
                        <div className={styles.bigText}>
                            Conseil et stratégie en transformation digitale
                        </div>
                        <div className={styles.paragraph}>
                            Alliant expertise métier et polyvalence, nos équipes vous accompagnent tout au long du processus de votre transformation digitale
                        </div>
                        <div className={styles.arrowContainer}>
                        <Link to="/services/transformation_digital">
                                <div class={styles.arrow}>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className={styles.service}>
                        <img src="/icons/integration.png" alt="ERP" />
                        <div className={styles.bigText}>
                            Intégration ERP
                        </div>
                        <div className={styles.paragraph}>
                            Notre équipe d’experts intervient tout au long du processus d’implémentation d’un logiciel ERP depuis la phase
                            d’étude jusqu’à l’exploitation et la mise en évolution du logiciel implanté.
                        </div>
                        <div className={styles.arrowContainer}>

                        <Link to="/services/erp">
                                <div class={styles.arrow}>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className={styles.service}>
                        <img src="/icons/seo.png" alt="SEO" />
                        <div className={styles.bigText}>
                            SEO et optimisation
                        </div>
                        <div className={styles.paragraph}>
                            Opter pour une stratégie d'acquisition efficace et long terme de référencement.
                        </div>
                        <div className={styles.arrowContainer}>
                        <Link to="/services/seo">
                                <div class={styles.arrow}>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Intro;